import type { FilterSchema } from '@which/reviews-filter-definitions'
import type { FilterData } from '@which/shared'

import type { NeedsBasedAnswerOptionExtended } from '../../../../shared/types'
import { getFilterAttributeValue } from '../components/Filter/utils'
import { checkToFromValues } from './check-to-from-values'
import { getNeedsBasedFilters } from './get-needs-based-filters'
import { mapNeedsBasedFilterBucketOptions } from './map-needs-based-filter-bucket-options'

export const matchedNeedsBasedOptionsAndLabels = ({
  filterData,
  filterSchemas,
}: {
  filterData: FilterData
  filterSchemas: FilterSchema[]
}) => {
  const needsBasedFilters = getNeedsBasedFilters({ filterSchemas })

  const selectedCollection = needsBasedFilters.reduce((collection: TransformedBucket[], filter) => {
    let bucketOptionsLength = 0

    filter.buckets.filter((bucket) => {
      const transformedOptions = mapNeedsBasedFilterBucketOptions({
        matchedNeedsBasedFilterBucket: bucket,
        filterSchemas,
      })

      const filterDataHasAllOptions = transformedOptions?.every(
        ({ valueBool, valueStr, from, to, externalId, code, componentType }) => {
          const attributeValue = getFilterAttributeValue({ valueBool, valueStr, from, to })

          if (externalId && componentType === 'dropdown') {
            return checkToFromValues({
              to,
              from,
              filterData,
              externalId,
            })
          }

          return externalId && code && filterData?.[externalId]?.[code]?.includes(attributeValue)
        }
      )

      if (
        filterDataHasAllOptions &&
        transformedOptions &&
        transformedOptions.length > bucketOptionsLength
      ) {
        bucketOptionsLength = transformedOptions.length

        collection.push({
          options: transformedOptions,
          segmentLabel: filter.segmentLabel,
          bucketLabel: bucket.label,
        })
      }
    })

    return collection
  }, [])

  return selectedCollection.reduce(
    (matchedMap, filter) => {
      matchedMap.options[filter.segmentLabel] = filter.options
      matchedMap.labels[filter.segmentLabel] = filter.bucketLabel
      return matchedMap
    },
    { options: {}, labels: {} }
  )
}

type TransformedBucket = {
  options: NeedsBasedAnswerOptionExtended[]
  segmentLabel: string
  bucketLabel: string
}
